/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsCloudProviderLight {
    getFixupPrototypeFunction() { return FilterOptionsCloudProviderLight.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsCloudProviderLight>): FilterOptionsCloudProviderLight {
        let obj = Object.assign(new FilterOptionsCloudProviderLight(), model);
        FilterOptionsCloudProviderLight.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsCloudProviderLight>): FilterOptionsCloudProviderLight {
        if (!model) return null;
        return FilterOptionsCloudProviderLight.newInstance(<FilterOptionsCloudProviderLight> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsCloudProviderLight) {
        if (!obj) return;

        models.FilterOptionsCloudProviderLight.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsCloudProviderLight): boolean {
        Object.setPrototypeOf(obj, FilterOptionsCloudProviderLight.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Provider for the accounts
     */
    cloud: models.CloudServiceName;

    /**
     * Currencies
     */
    currencies: Array<models.Currency>;

}
